var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('NavigationBar'),(_vm.$store.state.isLoaded)?_c('b-container',{staticStyle:{"max-width":"1360px"}},[_c('router-view')],1):_vm._e(),(!_vm.$store.state.isLoaded)?_c('b-container',[_c('center',[_c('h2',[_vm._v("Ładowanie aplikacji...")])])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }